export const liveCalculationTheme = {
  bg: 'palette.surface.4',
  divider: 'palette.tertiary.30',
  figure: 'palette.tertiary.70',
  label: 'palette.tertiary.60',
  subline: 'palette.tertiary.60',
  warning: {
    text: 'palette.error.60',
  },
};
